import React from 'react';
import {
  Box,
  Stack,
  TextField,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
} from '@mui/material';

import ImportImage from 'js/components/TriiboComponents/ImportImage';

export default function CardUrl({
  formCard,
  setFormCard,
  url,
  setUrl,
  handleMaskUrl,
  errorUrl,
  typeLink,
  setTypeLink,
  cardDefault,
  setCardDefault,
  setScrollPosition,
  cardDefaultDetails,
  setCardDefaultDetails,
  setIsActiveOverflow,
  modalRef,
  chooseDate,
  handleDates,
  handleDateDefined,
  isPrivateCard,
  handlePrivacityCard,
  handlePublished,
}) {
  return (
    <>
      <Stack spacing={2} mt={2}>
        <TextField
          required
          fullWidth
          label="Título do card"
          inputProps={{ maxLength: 100 }}
          value={formCard.title}
          onChange={(event) => setFormCard({ ...formCard, title: event.target.value })}
          onBlur={(e) => e.preventDefault()}
          onFocus={(e) => e.preventDefault()}
        />

        <TextField
          required
          fullWidth
          label="Url"
          InputLabelProps={{ shrink: url !== '' }}
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onBlur={handleMaskUrl}
          onFocus={(e) => e.preventDefault()}
          error={errorUrl}
          helperText={errorUrl ? 'Uma url válida deve ser inserida' : ''}
        />

        <FormControl fullWidth>
          <InputLabel>Abrir link em:</InputLabel>
          <Select
            value={typeLink}
            label="Abrir link em:"
            onChange={(e) => setTypeLink(e.target.value)}
          >
            <MenuItem value={'new-guide'}>Nova guia</MenuItem>
            <MenuItem value={'inside-frame'}>Conteúdo interno</MenuItem>
            <MenuItem value={'full-frame'}>Conteúdo completo</MenuItem>
          </Select>
        </FormControl>

        <TextField
          required
          fullWidth
          multiline
          label="Descrição"
          value={formCard.description}
          onChange={(e) => setFormCard({ ...formCard, description: e.target.value })}
          onBlur={(e) => e.preventDefault()}
          onFocus={(e) => e.preventDefault()}
        />
      </Stack>

      <Box mt={4}>
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="subtitle1" fontWeight="bold">
            Imagem do card:
          </Typography>
          <Box mt={1} mb={2}>
            <Typography variant="subtitle1">Selecione a imagem para seu card:</Typography>
          </Box>
        </Box>
        <Stack spacing={2}>
          <Box mb={2}>
            <Typography variant="subtitle2" fontWeight="bold" mb={1}>
              Imagem para desktop e mobile:
            </Typography>
            <ImportImage
              imageDefault={true}
              autoWidth={true}
              image={cardDefault}
              setImage={setCardDefault}
              ratio={2.81 / 1}
              allowFreeCrop={true}
              refScroll={modalRef}
              setScrollPosition={setScrollPosition}
              setIsActiveOverflow={setIsActiveOverflow}
            />
          </Box>
          <Box>
            <Typography variant="subtitle2" fontWeight="bold" mb={1}>
              Imagem para detalhes do card:
            </Typography>
            <ImportImage
              imageDefault={true}
              autoWidth={true}
              image={cardDefaultDetails}
              setImage={setCardDefaultDetails}
              ratio={1.33 / 1}
              allowFreeCrop={true}
              refScroll={modalRef}
              setScrollPosition={setScrollPosition}
              setIsActiveOverflow={setIsActiveOverflow}
            />
          </Box>
        </Stack>
      </Box>

      <Stack spacing={1} mt={3}>
        <FormControlLabel
          sx={{ mt: 4 }}
          control={<Switch checked={chooseDate} onChange={handleDateDefined} color="primary" />}
          label="Definir data de expiração do card?"
        />
        {chooseDate && (
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2}>
            <TextField
              fullWidth
              id="datetime-local"
              label="Data de ativação"
              type="datetime-local"
              value={formCard.enableDate}
              onChange={handleDates('enableDate')}
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              fullWidth
              id="datetime-local"
              label="Data de desativação"
              type="datetime-local"
              value={formCard.disableDate}
              onChange={handleDates('disableDate')}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Stack>
        )}
        <FormControlLabel
          control={
            <Switch checked={isPrivateCard} onChange={handlePrivacityCard} color="primary" />
          }
          label="Visível apenas para membros?"
        />
        <FormControlLabel
          control={
            <Switch checked={formCard.isPublished} onChange={handlePublished} color="primary" />
          }
          label="Publicar card?"
        />
      </Stack>
    </>
  );
}
